import { c as _c } from "react/compiler-runtime";
import { Box } from '@mui/material';
import type * as v from 'valibot';
import type { StructuredContentDocumentWithRenderer } from '../../hydration/types';
import { renderStructuredContent } from '../../renderContext';
import type { CreditCardsCardListSCSchema } from './schema';
export type CreditCardsCardListProps = StructuredContentDocumentWithRenderer<v.InferInput<typeof CreditCardsCardListSCSchema>>;
export const CreditCardsCardList = t0 => {
  const $ = _c(8);
  const {
    props
  } = t0;
  const {
    children,
    cardGap: t1
  } = props;
  const cardGap = t1 === undefined ? "32px" : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      xs: "column",
      sm: "row"
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== cardGap) {
    t3 = {
      marginY: 4,
      display: "flex",
      flexDirection: t2,
      gap: {
        xs: 3,
        sm: cardGap
      }
    };
    $[1] = cardGap;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== children) {
    t4 = renderStructuredContent(children);
    $[3] = children;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t3 || $[6] !== t4) {
    t5 = <Box sx={t3}>{t4}</Box>;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
};